import { setDeviceState } from '../../redux/actions';

export default class deviceState {

    constructor(dispatch) {
        this.dispatch            = dispatch;                      //redux action dispatch function
        //this.indicator           = document.createElement('div'); //div element to use for measurement
        //this.indicator.className = 'state-indicator';             //div class
        this.debounce_delay      = 250;                           //debounce delay in milliseconds
        //document.body.appendChild(this.indicator);
        this.dispatch(setDeviceState(this.getScreen()));
        this.start();
    };

    //returns the current device state according to the width of the screen as measured by
    //the state-indicator div.
    getScreen = () => {
        //var index = parseInt(window.getComputedStyle(this.indicator).getPropertyValue('z-index'), 10);

        var size = window.innerWidth;
        //parse the screen size to state index
        var index = this.parseToIndex(size);

        var states = {
            1: 'desktop_large',
            2: 'desktop',
            3: 'tablet',
            4: 'mobile'
        };
        return states[index] || 'desktop';
    };

    parseToIndex(size){
        let index = 4;
        if(size < 768) {
            index = 4;
        }
        else if (size >= 768 && size < 1200) {
            index = 3;
        }
        else if ( size >= 1200 && size < 1500 ){
                index = 2;
            }
        else if ( size >= 1500){
                index = 1;
            }
            return index;
    }

    //Debounce the device state function so that it is called only once every 250ms
    debounce(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
    };
}

    start = () => {
        //Listen for screen resize with a debounce
        var response  = this.debounce(() => {

            //determine current device
            let device = this.getScreen();

            //set device type in the redux store
            this.dispatch(setDeviceState(device));

        }, this.debounce_delay, false);

        window.addEventListener('resize', response);
        response();
    }
}


